import { Grid, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { MailList } from "../feature/OrganisationApi/mailList"

export const MailOverviewPage = () => {
    const { t } = useTranslation()

    return (

        <Grid container spacing={5}>
            <Grid item xs={6}>
                <Stack direction="row">
                    <Typography variant="h5">{t("Mail overview") + ""}</Typography>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <MailList />
            </Grid>
        </Grid>

    )
}